"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserClient = useUserClient;
const UserClient_1 = require("@juvare/platform-sdk-js/UserClient");
const react_1 = __importDefault(require("react"));
function useUserClient(baseUrl, tokenProvider) {
    return react_1.default.useMemo(() => new UserClient_1.UserClient(baseUrl, tokenProvider), [baseUrl, tokenProvider]);
}
